// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (typeof exports == "object" && typeof module == "object") // CommonJS
    mod(require("codemirror"));
  // else if (typeof define == "function" && define.amd) // AMD
  //   define(["../../lib/codemirror"], mod);
  // else // Plain browser env
    // mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

  CodeMirror.defineSimpleMode("pat", {
    // The start state contains the rules that are intially used
    start: [
      {regex: /0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i, token: "number"},
      // {
      //   regex: /^(-?\d+\.?\d*)(\,?\s*)(-?\d+\.?\d*)(\,?\s*)(-?\d+\.?\d*)(\,?\s*)(-?\d+\.?\d*)(\,?\s*)(-?\d+\.?\d*)/,
      //   token: [
      //     "number n-angle",
      //     " ",
      //     "number n-x",
      //     " ",
      //     "number n-y",
      //     " ",
      //     "number n-shift",
      //     " ",
      //     "number n-offset",
      //   ]
      // },
      // {
      //   regex: /^(-?\d+\.?\d*)(\,?\s*)(-?\d+\.?\d*)(\,?\s*)(-?\d+\.?\d*)(\,?\s*)(-?\d+\.?\d*)(\,?\s*)(-?\d+\.?\d*)(\,?\s*)(-?\d+\.?\d*)(\,?\s*)(-?\d+\.?\d*)/,
      //   token: [
      //     "number n-angle",
      //     " ",
      //     "number n-x",
      //     " ",
      //     "number n-y",
      //     " ",
      //     "number n-shift",
      //     " ",
      //     "number n-offset",
      //     " ",
      //     "number n-dash",
      //     " ",
      //     "number n-space"
      //   ]
      // },
      // {
      //   regex: /(\,?\s*)(-?\d+\.?\d*)(\,?\s*)(-?\d+\.?\d*)/,
      //   token: [
      //     " ",
      //     "number n-dash",
      //     " ",
      //     "number n-space",
      //   ]
      // },
      // {
      //   regex: /(-?\d+.?\d*)(?:\,?\s*)(-?\d+.?\d*)(?:\,?\s*)/,
      //   token: [
      //     "number n-dash",
      //     "number n-space"
      //   ]
      // },
      // {regex: /(0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?)(,\s+)(0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?)(,\s+)(0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?)(,\s+)(0x[a-f\d]+|[-+]?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?)/i, token: ["angle number", "space", "x number", ]},
      {regex: /;angle|x|y|shift|offset|dash|space/, token: "column-header"},
      {regex: /;[^%].*/, token: "comment"},
      {regex: /\*.*/, token: "title"},
      {regex: /(;%VERSION=)(.*)/, token: ["setting-label", "setting"]},
      {regex: /(;%UNITS=)(.*)/, token: ["setting-label", "setting"]},
      {regex: /(;%TYPE=)(.*)/, token: ["setting-label", "setting"]},
    ]
  });

});



// WEBPACK FOOTER //
// ./src/components/SuperEditor/codemirror-pat.js